"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PersonalAgreement = require("./PersonalAgreement");
Object.keys(_PersonalAgreement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PersonalAgreement[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PersonalAgreement[key];
    }
  });
});